import { Location } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { from, mergeMap, take } from 'rxjs';
import { CommonUtils } from 'src/app/core/utils/common/common.utils';
import { BUTTON_CLICK } from '../../shared/modal/exit-modal/exit-modal.constants';
import { CONSTS } from './logout.constants';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
})
export class LogoutComponent implements OnInit {
  readonly msalService = inject(MsalService);
  private location = inject(Location);
  private commonUtils = inject(CommonUtils);

  ngOnInit(): void {
    this.commonUtils
      .openWarningModal({
        header: CONSTS.HEADER,
        body: CONSTS.CONFIRMATION,
      })
      .afterClosed()
      .subscribe((resp) => {
        if (resp.button === BUTTON_CLICK.ACCEPT) {
          this.handleAcceptClick();
        }
        if (resp.button === BUTTON_CLICK.REJECT) {
          this.handleBackClick();
        }
      });
  }

  private handleAcceptClick() {
    from(this.msalService.instance.initialize())
      .pipe(
        take(1),
        mergeMap(() => {
          const activeAccount =
            this.msalService.instance.getActiveAccount() ??
            this.msalService.instance.getAllAccounts()[0];

          localStorage.clear();
          sessionStorage.clear();
          this.msalService.instance.logoutRedirect({
            account: activeAccount,
          });

          return from(
            this.msalService.instance.clearCache({
              correlationId: 'test-clear-cache',
              account: activeAccount,
            }),
          );
        }),
      )
      .subscribe();
  }

  private handleBackClick() {
    this.location.back();
  }
}
